export default __webpack_public_path__ + "static/media/ai-ux-comm-cover.aae5947b.png";